var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92683 8.04938C8.92683 4.69543 11.6424 2 14.9634 2C18.2844 2 21 4.69543 21 8.04938C21 8.66303 20.5086 9.16049 19.9024 9.16049C19.2963 9.16049 18.8049 8.66303 18.8049 8.04938C18.8049 5.94867 17.0979 4.22222 14.9634 4.22222C12.8289 4.22222 11.122 5.94867 11.122 8.04938V11.8765H17.9268C18.533 11.8765 19.0244 12.374 19.0244 12.9877C19.0244 13.6013 18.533 14.0988 17.9268 14.0988H11.122V14.963C11.122 16.8292 10.3986 18.521 9.22049 19.7778H19.9024C20.5086 19.7778 21 20.2752 21 20.8889C21 21.5025 20.5086 22 19.9024 22H4.09756C3.49139 22 3 21.5025 3 20.8889C3 20.2752 3.49139 19.7778 4.09756 19.7778C6.77759 19.7778 8.92683 17.6091 8.92683 14.963V14.0988H4.09756C3.49139 14.0988 3 13.6013 3 12.9877C3 12.374 3.49139 11.8765 4.09756 11.8765H8.92683V8.04938Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPound);
export default __webpack_public_path__ + "static/media/pound.82d37ffc4cbb8ef2d9d52756759db4bb.svg";
export { ForwardRef as ReactComponent };